import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import './TestResult.css'
import LoadingScreen from '../components/LoadingScreen'

const TestResult = () => {
  const [testData, setTestData] = useState(null)
  const [result, setResult] = useState(null)
  const [attemptId, setAttemptId] = useState(null)
  const [loading, setLoading] = useState(true)
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (location.state) {
      setTestData(location.state.testData)
      setResult(location.state.result)
      setAttemptId(location.state.attemptId)
      setLoading(false)
    } else {
      // If no state, redirect to dashboard
      history.push('/student-dashboard')
    }
  }, [location.state, history])

  const handleBackToDashboard = () => {
    // Use full page reload to ensure camera is properly released
    window.location.href = '/student-dashboard'
  }

  const handleViewDetails = () => {
    history.push(`/test-details/${attemptId}`)
  }

  const handleRetakeTest = () => {
    if (testData) {
      history.push(`/test-taking/${testData.id}`)
    }
  }

  if (loading) {
    return <LoadingScreen message="Loading Test Results" />
  }

  if (!testData || !result) {
    return (
      <div className="test-result-container">
        <div className="error">No test data found</div>
        <button onClick={handleBackToDashboard}>
          Back to Dashboard
        </button>
      </div>
    )
  }

  const isPassed = result.passed
  const scoreColor = isPassed ? '#38a169' : '#e53e3e'
  const statusText = isPassed ? 'PASSED' : 'FAILED'

  return (
    <div className="test-result-container">
      <div className="result-card">
        <div className="result-header">
          <h1>Test Results</h1>
          <div className={`status-badge ${isPassed ? 'passed' : 'failed'}`}>
            {statusText}
          </div>
        </div>

        <div className="test-info">
          <h2>{testData.title}</h2>
          <p className="test-description">{testData.description}</p>
        </div>

        <div className="score-section">
          <div className="score-circle">
            <div className="score-number" style={{ color: scoreColor }}>
              {result.percentage}%
            </div>
            <div className="score-label">Final Score</div>
          </div>
          
          <div className="score-details">
            <div className="score-item">
              <span className="score-label">Points Earned:</span>
              <span className="score-value">{result.score}</span>
            </div>
            <div className="score-item">
              <span className="score-label">Total Points:</span>
              <span className="score-value">{result.total_points}</span>
            </div>
            <div className="score-item">
              <span className="score-label">Passing Score:</span>
              <span className="score-value">{testData.passing_score}%</span>
            </div>
            <div className="score-item">
              <span className="score-label">Submitted At:</span>
              <span className="score-value">
                {new Date(result.submitted_at).toLocaleString()}
              </span>
            </div>
          </div>
        </div>

        <div className="result-message">
          {isPassed ? (
            <div className="success-message">
              <div className="message-icon">🎉</div>
              <div className="message-content">
                <h3>Congratulations!</h3>
                <p>You have successfully passed the test. You can now download your certificate.</p>
              </div>
            </div>
          ) : (
            <div className="failure-message">
              <div className="message-icon">📚</div>
              <div className="message-content">
                <h3>Keep Learning!</h3>
                <p>You didn't meet the passing score this time. Review the material and try again.</p>
              </div>
            </div>
          )}
        </div>

        <div className="result-actions">
          <button 
            className="primary-button"
            onClick={handleBackToDashboard}
          >
            Back to Dashboard
          </button>
          
          <button 
            className="secondary-button"
            onClick={handleViewDetails}
          >
            View Detailed Results
          </button>
          
          {!isPassed && (
            <button 
              className="retake-button"
              onClick={handleRetakeTest}
            >
              Retake Test
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default TestResult
